import type {ItemModelType} from "../stores/WorkspaceStore";

export const isPinned = (item: ItemModelType) => {
    return item.pinned && !item.trashed && !item.archived
}